<template>
  <div>
    <div class="grid grid-cols-2">
      <div class="font-bold">Items subtotal ({{ totalQuantity }}):</div>
      <div class="text-right">{{ totalSubtotal | currency }}</div>
      <div class="font-bold">Order Discount</div>
      <div class="text-right">-{{ totalDiscount | currency }}</div>
      <div class="font-bold">Taxes</div>
      <div class="text-right">{{ totalTax | currency }}</div>
    </div>
    <div class="grid grid-cols-2 pt-2 mt-2 border-t border-gray-300">
      <div class="font-bold">Claim Total</div>
      <div class="text-right">{{ totalRefund | currency }}</div>
    </div>
  </div>
</template>

<script>
import MoneyFormatter from "@/mixins/moneyFormatter";

export default {
  name: "RefundValueSummary",
  components: {},
  filters: {
    currency: MoneyFormatter.format
  },
  mixins: [MoneyFormatter],
  props: {
    calculatedRefund: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    totalRefund() {
      return this.calculatedRefund.transactions.reduce(
        (partialSum, item) => partialSum + Number(item?.amount),
        0
      );
    },
    totalDiscount() {
      return this.calculatedRefund.refund_line_items.reduce(
        (partialSum, item) =>
          partialSum + Number(item?.total_cart_discount_amount),
        0
      );
    },
    totalTax() {
      return this.calculatedRefund.refund_line_items.reduce(
        (partialSum, item) => partialSum + Number(item?.total_tax),
        0
      );
    },
    totalSubtotal() {
      return this.calculatedRefund.refund_line_items.reduce(
        (partialSum, item) => {
          // If the item has a discount, use the discounted price, otherwise use the regular price
          const price =
            Number(item?.discounted_price) > 0
              ? Number(item?.discounted_price)
              : Number(item?.price);
          return partialSum + price * Number(item?.quantity);
        },
        0
      );
    },
    totalQuantity() {
      return this.calculatedRefund.refund_line_items.reduce(
        (partialSum, item) => partialSum + item?.quantity,
        0
      );
    }
  },
  watch: {},
  created() {},
  methods: {}
};
</script>
